import { useRouter } from 'found';
import React, { Suspense, useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import makeStyles from '@mui/styles/makeStyles';
import useIsMobile from 'lib/useIsMobile';
import Main from '../ripple/Containers/Main';
import { GET_PROFILE_INFO } from '../schema/apolloQueries/commonQueries';

const Survey = React.lazy(() => import('survey/Survey'));
const buttonStyles = makeStyles((theme) => ({
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(360deg)',
    },
    '100%': {
      transform: 'rotate(0deg)',
    },
  },

  dialogContent: {
    overflowY: 'unset',
    fontFamily: theme.typography.fontFamily,
    color: '#000',
    backgroundColor: 'white',

  },

}));

const modelMap = {
  g: 'GLOBAL',
  e: 'EVENT',
  c: 'COMMUNITY',
};

const Lucy = () => {
  const classes = buttonStyles();
  const mobile = useIsMobile();
  const {
    match: {
      params: { slug, model = 'e' },
    },
    router,
  } = useRouter();
  const [renderSurvey, setRenderSurvey] = useState(null);

  const { data, loading } = useQuery(GET_PROFILE_INFO);

  const userId = data?.getProfile?.personInfo
    ? data?.getProfile?.personInfo.id
    : 0;

  useEffect(() => {
    if (slug && !loading) {
      setRenderSurvey(
        <Suspense fallback='Loading Profile Update...'>
          <div style={{ display: 'flex', justifyContent: 'center', minHeight: 'inherit' }}>
            <div
              className={classes.dialogContent}
              style={{ width: mobile ? '100%' : '50%', padding: '40px' }}
            >
              <Survey
                pageSize={1}
                hasNextAction={false}
                context={{ personId: userId, model: modelMap[model], slug }}
                callback={() => {
                  router.push('/discover/events');
                }}
              />
            </div>
          </div>
        </Suspense>,
      );
    }
  }, [userId, slug, mobile, loading]);

  return (
    <Main>
      {renderSurvey}
    </Main>
  );
};

export default Lucy;
